import * as React from "react"
import HeroSection from "../organs/HeroSection"
import Services from "../organs/Services"
import Testimonial from "../organs/Testimonial"
import FinalCTA from "../organs/FinalCTA"

const Home = () => {
    return (
        <main className="bg-white text-slate-900">
            <HeroSection/>
            <Services/>
            <Testimonial/>
            <FinalCTA/>
        </main>
    )
}

export default Home
